import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl } from 'react-intl';
import TextField from '../../TextField/TextField';
import { isEmpty } from '../../FormElement/FormElementUtils';
import PropTypes from 'prop-types';

//Copying current pattern matching textinput uses in CAPE
export const isDEValidPostalCode = (msg) => (value) => {
    const pattern = /^\b((?:0[1-46-9]\d{3})|(?:[1-357-9]\d{4})|(?:[4][0-24-9]\d{3})|(?:[6][013-9]\d{3}))\b$/;

    if (pattern.test(value)) {
        return;
    } else {
        return {
            msg,
            className: 'hasError'
        };
    }
};
export const isGBValidPostalCode = (msg) => (value) => {
    const pattern = /^[a-zA-Z]{1,2}[0-9][0-9a-zA-Z]?\s?[0-9][a-zA-Z]{2}$/;

    if (pattern.test(value)) {
        return;
    } else {
        return {
            msg,
            className: 'hasError'
        };
    }
};


export class PostalCode extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        localePrefix: PropTypes.string.isRequired,
        country: PropTypes.string.isRequired,
        ariadescribedby: PropTypes.string,
        idPrefix: PropTypes.string
    };
    render() {
        const { intl, idPrefix, localePrefix, country, ariadescribedby} = this.props;


        let validation;
        if (country === 'gb') {
            validation = [isEmpty(intl.formatMessage({id: `${localePrefix}.POSTCODE_IS_NULL`})), isGBValidPostalCode(intl.formatMessage({id: `${localePrefix}.POSTCODE_INVALID_FORMAT`}))] ;
        } else if (country == 'de') {
            validation = [isEmpty(intl.formatMessage({id: `${localePrefix}.POSTCODE_IS_NULL`})), isDEValidPostalCode(intl.formatMessage({id: `${localePrefix}.POSTCODE_INVALID_FORMAT`}))];
        }
        return (
            <Field
                id={idPrefix ? `${idPrefix}-postalCode` : 'postalCode'}
                name="postalCode"
                require={true}
                component={TextField}
                label={intl.formatMessage({id: `${localePrefix}.postCode`})}
                maxLength="8"
                ariadescribedby={ariadescribedby}
                validate={validation}
            />
        );
    }
}

export default injectIntl(PostalCode);

